export const GET_SETTLEMENT_TRANSACTION_BATCHES = "GET_SETTLEMENT_TRANSACTION_BATCHES";
export const GET_SETTLEMENT_TRANSACTION = "GET_SETTLEMENT_TRANSACTION";
